import { v4 as uuidv4 } from 'uuid';

/**
 * By default, MirageJS uses the auto increment method of integer IDs to ensure that primary keys
 * are unique for each schema. Since we want to use UUIDs as the primary keys for seeded
 * data, we must instruct MirageJS to use this class to handle identity management of
 * seeded data.
 */
export default class {
  constructor() {
    this.ids = new Set();
  }

  // Returns a new unused unique identifier.
  fetch() {
    let uuid = uuidv4();
    while (this.ids.has(uuid)) {
      uuid = uuidv4();
    }

    this.ids.add(uuid);

    return uuid;
  }

  // Registers an identifier as used. Must throw if identifier is already used.
  set(id) {
    if (this.ids.has(id)) {
      throw new Error(`ID ${id} has already been used.`);
    }

    this.ids.add(id);
  }

  // Resets all used identifiers to unused.
  reset() {
    this.ids.clear();
  }
}
